var map = {
	"./AntragBewilligt.png": "16db",
	"./Durchsuchen.png": "01c9",
	"./FertigAntrag.png": "2981",
	"./Forschung.png": "5899",
	"./Forschungsergebnis.png": "e8b8",
	"./Idee.png": "3430",
	"./Patientenversorgung.png": "a01b",
	"./Pseudonymisierung.png": "2b13",
	"./Routine.png": "7c82",
	"./Rückführung.png": "8c9d",
	"./UAC.png": "c367",
	"./Visualisierung.png": "6ebe"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1dbe";